<template>
  <div class="main-app">
    <header>
      <Navigation type="admin"></Navigation>
    </header>
    <main style="padding: 0 15px;">
      <content>
        <slot></slot>
      </content>

      <footer>
      </footer>
    </main>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
  name: 'Admin',
  components: { Navigation }
}
</script>
